import { useCallback, useEffect, useState } from 'react';
import { getSupportUnreadCount } from '../api';

export const SUPPORT_UPDATED_EVENT = 'support-updated';
const POLL_MS = 60_000;

export const notifySupportUpdated = () =>
  window.dispatchEvent(new Event(SUPPORT_UPDATED_EVENT));

/** Пользователю — обращения с непрочитанным ответом, поддержке — ждущие ответа. */
export function useSupportUnread(enabled: boolean) {
  const [count, setCount] = useState(0);

  const load = useCallback(async () => {
    if (!enabled) {
      setCount(0);
      return;
    }
    try {
      setCount(await getSupportUnreadCount());
    } catch {
      // Счётчик вспомогательный: ошибку покажет сама страница поддержки.
    }
  }, [enabled]);

  useEffect(() => {
    void load();
    if (!enabled) return undefined;
    const timer = window.setInterval(() => void load(), POLL_MS);
    window.addEventListener(SUPPORT_UPDATED_EVENT, load);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener(SUPPORT_UPDATED_EVENT, load);
    };
  }, [enabled, load]);

  return count;
}
